export default function printTableStyles(colLength) {
  return `
    #root > * {
        display: none;
    }
    #root > main {
        display: block;
    }
    #root > header > *, #root > main > * , #root > footer > *, svg {
        display: none;
    }
    #root > main > div.model-specifications-table-analytics-wrapper {
        display: block;
    }
    #root > main > div.model-specifications-table-analytics-wrapper > * {
        display: none;
    }
    #root > main > div.model-specifications-table-analytics-wrapper > .model-details-specification-table-wrapper {
        display: block;
    }
    #root > main > div.model-specifications-table-analytics-wrapper > .model-details-specification-table-wrapper > .model-details-specification-table-header,
    #root > main > div.model-specifications-table-analytics-wrapper > .model-details-specification-table-wrapper > .model-detail-specification-table,
    #root > main > div.model-specifications-table-analytics-wrapper > .model-details-specification-table-wrapper > .model-detail-specification-table__search-no-match {
        display: none;
    }
    #root > main > div.model-specifications-table-analytics-wrapper > .model-details-specification-table-wrapper > .model-detail-specification-table-print {
        display: block;
        overflow: hidden;
        width: 100%;
    }
    .model-detail-specification-table-print {
        width: 100%;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__grid {
        display: grid;
        position: relative;
        grid-template-columns: repeat(${colLength}, auto);
        align-items: center;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print-wrapper .print-navigation-logo-image{
        margin: 20px;
        display: block;
        width: auto;
        max-height: 40px;
        height: 40px
    }
    .model-detail-specification-table-print__image {
        grid-column: 1 / -1;
    }
    .model-detail-specification-table__fixed-col-heading {
        display: none;
    }
    .model-detail-specification-table-print__col-heading {
        color: #a71930;
        font-weight: 700;
        position: relative;
        font-size: 12px;
        line-height: 20px;
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
        padding: 8px 0 4px 16px;
    }
    .model-detail-specification-table-print__spec {
        color: #1e1e1d;
        font-size: 12px;
        line-height: 20px;
        border-bottom: 1px solid #d1d2d4;
        display: flex;
        height: 100%;
        align-items: center;
        padding: 16px;
    }
    .model-detail-specification-table-print__spec--even {
        background-color: #ffffff;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec--odd {
        background-color: #fbfbfb;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec--last-row {
        border: 0;
    }
    .model-detail-specification-table-print__spec-category-row {
        color: #1e1e1d;
        font-weight: 700;
        background-color: #f4f4f4;
        -webkit-print-color-adjust: exact;
        display: flex;
        grid-column: 1/-1;
        cursor: pointer;
    }
    .model-detail-specification-table-print__spec-category-row__empty-row {
        flex-grow: 1;
    }
    .model-detail-specification-table-print__spec-category-row__inner-box-wrapper {
        z-index: 2;
        background-color: #f4f4f4;
        -webkit-print-color-adjust: exact;
    }
    .model-detail-specification-table-print__spec-category-row__border-collapsed {
        border-bottom: 1px solid #d1d2d4;
    }
    .model-detail-specification-table-print__spec-category-row__inner-box {
        margin-left: 32px;
        padding: 16px 0;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title {
        font-size: 12px;
        line-height: 20px;
        background-color: #fbfbfb;
        -webkit-print-color-adjust: exact;
        font-weight: 600;
        display: flex;
        height: 100%;
        z-index: 2;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title__inner-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #d1d2d4;
        margin-left: 32px;
        padding: 16px 16px 16px 0;
    }
    .model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row {
        border: 0;
    }
    .model-detail-specification-table-print__spec-row-child {
      height: 100%;
      display: flex;
      align-items: center;
      opacity: 1;
    }
    `;
}
